<template>
  <div class="wrapper">
    <div class="twoSideBox">
      <div class="leftBox" ref="treeBox" style="width: 200px">
        <h3 class="centerFont">考生分组</h3>
        <mytree
          :searchInput="true"
          :treeData="studentGroupTree"
          @eventUp="studentGroupEvent"
        ></mytree>
      </div>
      <div class="slider" @mousedown="sliderClick"></div>
      <div class="rightBox">
        <div class="actBar">
          <el-dropdown @command="appendStudent">
            <el-button type="primary" size="small">
              添加考生<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="true">手动添加</el-dropdown-item>
              <el-dropdown-item :command="false">批量导入</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          &ensp;
          <el-button
            type="primary"
            size="small"
            @click="appendExamStudent('examImport')"
          >
            批量导入准考证
          </el-button>
          &ensp;
          <el-button
            type="primary"
            size="small"
            @click="appendExamStudent('create')"
          >
            生成准考证
          </el-button>
          &ensp;
          <el-button
            type="primary"
            size="small"
            @click="appendExamStudent('download')"
          >
            导出准考证
          </el-button>
          &ensp;

          <el-dropdown @command="moveStuGroup">
            <el-button type="primary" size="small" plain>
              移动到组<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="true"
                >移动考生到多个组</el-dropdown-item
              >
              <el-dropdown-item :command="false">移动到组</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          &ensp;
          <el-dropdown :hide-on-click="false">
            <el-button type="primary" size="small" plain>
              显示列<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-checkbox v-model="column.faceUrl">照片</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="column.userName">姓名</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="column.groupName">组名</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="column.mobile">手机</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="column.sex">性别</el-checkbox>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            :disabled="
              $refs.studentListTable &&
              $refs.studentListTable.selection.length == 0
            "
            style="margin-left: 15px"
            type="danger"
            size="small"
            @click="batchDeleteStudent"
            >删除考生</el-button
          >
        </div>
        <div class="searchBar">
          <el-pagination
            layout="prev, pager, next"
            :current-page.sync="searchCondition.jumpPage"
            :page-size.sync="searchCondition.pageSize"
            :total="searchCondition.total"
            @current-change="getStudentList"
          >
          </el-pagination>
          <el-input
            placeholder="请输入内容"
            v-model="searchValue"
            style="width: 360px"
            size="small"
          >
            <el-select
              v-model="searchKey"
              slot="prepend"
              placeholder="请选择"
              style="width: 100px"
            >
              <el-option label="姓名" value="userName"></el-option>
              <el-option label="手机" value="mobile"></el-option>
              <el-option label="身份证" value="idCard"></el-option>
            </el-select>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="getStudentList"
            ></el-button>
          </el-input>
        </div>
        <el-table
          ref="studentListTable"
          :data="studentList"
          tooltip-effect="dark"
          style="width: 100%"
          :height="tableHeight"
          cell-class-name="centerFlex"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50"> </el-table-column>
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{
              (searchCondition.jumpPage - 1) * searchCondition.pageSize +
              scope.$index +
              1
            }}</template>
          </el-table-column>
          <el-table-column label="照片" width="60" v-if="column.faceUrl">
            <template slot-scope="{ row }"
              ><el-image
                class="tableAvatar"
                :src="row.faceUrl || defaultAvatar"
                fit="contain"
              >
                <div slot="error" class="image-slot">-</div></el-image
              ></template
            >
          </el-table-column>
          <el-table-column
            prop="userName"
            label="姓名"
            width="120"
            v-if="column.userName"
          >
          </el-table-column>
          <el-table-column
            prop="groupName"
            label="分组"
            v-if="column.groupName"
          >
          </el-table-column>
          <el-table-column
            prop="sex"
            label="性别"
            show-overflow-tooltip
            v-if="column.sex"
          >
          </el-table-column>
          <el-table-column
            prop="mobile"
            label="手机"
            show-overflow-tooltip
            v-if="column.mobile"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            fixed="right"
            width="160"
            label-class-name="centerFont"
          >
            <template slot-scope="{ row }">
              <el-button type="text" @click="toEditStudent(row)"
                >编辑</el-button
              >
              <el-button type="text" @click="toDetail(row)">详情</el-button>
              <el-button type="text" @click="deleteStudent(row)"
                >删除</el-button
              >
              <!-- <el-button style="padding: 0" type="text">考生详情</el-button>
              &ensp;
              <el-dropdown>
                <el-button type="text" style="padding: 0">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <el-button type="text" @click="toEditStudent(row)"
                      >编辑</el-button
                    >
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button type="text" @click="deleteStudent(row)"
                      >删除</el-button
                    >
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog
      title="添加考生"
      :visible.sync="ifEditStudent"
      width="40%"
      append-to-body
    >
      <el-form
        ref="form"
        :model="editStudentData"
        label-width="100px"
        style="max-height: 56vh; overflow: scroll"
      >
        <el-form-item
          :label="item.name"
          v-for="item in applyKeyvalList"
          :key="'form' + item.field"
          style="margin-bottom: 0px"
        >
          <el-select
            v-if="item.field == 'sex'"
            v-model="editStudentData[item.field]"
            size="small"
            placeholder="请选择性别"
          >
            <el-option label="男" :value="1"></el-option>
            <el-option label="女" :value="2"></el-option>
          </el-select>
          <treeselect
            :groupTree="studentGroupTree"
            :groupChosenIds="editStudentData.groupIds"
            :showCheckbox="true"
            :checkStrictly="true"
            @eventUp="studentEditGroupEvent"
            :checkOnClickNode="true"
            :expandOnClickNode="false"
            v-else-if="item.field == 'groupIds'"
            ref="studentGroupSelectTree"
          ></treeselect>
          <el-upload
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            v-else-if="item.field == 'faceUrl'"
            :http-request="studentFaceUpload"
            :headers="{ Authorization: getStore('accessToken') }"
          >
            <img
              v-if="editStudentData.faceUrl"
              :src="editStudentData.faceUrl"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <el-input
            size="small"
            style="width: 80%"
            v-else
            v-model="editStudentData[item.field]"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="display: flex; justify-content: space-between">
        <el-dropdown :hide-on-click="false">
          <el-button size="small" icon="el-icon-arrow-down el-icon--right"
            >添加新字段</el-button
          >

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in keyvalSelectList"
              :key="'keyvalSelect' + index"
            >
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <el-checkbox
                  @change="(data) => studentEditKeyTraggle(item, data)"
                  :value="Object.keys(editStudentData).includes(item.field)"
                  >{{ item.name }}</el-checkbox
                >
                <i
                  class="el-icon-delete"
                  v-if="item.type == 2"
                  @click="deleteLabel(item)"
                ></i>
              </div>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-popover
                placement="top-start"
                title="标题"
                width="200"
                trigger="click"
              >
                <div>
                  <el-input size="mini" v-model="newLabelName"></el-input>
                  <el-button size="mini" @click="createLabel">确定</el-button>
                </div>
                <el-button slot="reference" size="small" style="width: 100%"
                  >添加新字段</el-button
                >
              </el-popover>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div>
          <el-button type="primary" @click="studentEditConfirm" size="small"
            >确定</el-button
          >
          <el-button
            type="primary"
            plain
            @click="ifEditStudent = false"
            size="small"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="groupMove.type ? groupMove.typeText : '移动考生至分组'"
      :visible.sync="groupMove.ifShow"
      width="60%"
      append-to-body
    >
      <mytree
        ref="groupMoveTree"
        :treeData="studentGroupTree"
        @eventUp="studentGroupEvent"
        :showCheckbox="groupMove.ifMulti"
        :checkStrictly="true"
        :checkOnClickNode="true"
      ></mytree>
      <div slot="footer">
        <el-button type="primary" @click="groupMoveConfirm" size="small"
          >确定</el-button
        >
        <el-button
          type="primary"
          plain
          @click="groupMove.ifShow = false"
          size="small"
          >取消</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="批量导入"
      :visible.sync="importData.ifShow"
      width="960px"
      :append-to-body="true"
    >
      <el-steps :active="importData.step">
        <el-step title="上传文件"></el-step>
        <el-step title="执行导入"></el-step>
        <el-step title="导入完成"></el-step>
      </el-steps>
      <div class="importStep" v-show="importData.step == 0">
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">填写导入的信息</div>
            <div class="detail">
              请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除
            </div>
            <div>
              <!-- <a href="/public/企业学员导入模板.xlsx" icon="md-album"
                >下载模板</a
              > -->

              <el-button
                type="text"
                size="mini"
                @click="download('../导入考生Excel模板.xlsx')"
                >下载模板</el-button
              >
            </div>
          </div>
        </div>
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">上传填好的考生信息表</div>
            <div class="detail">
              文件后缀名必须为xls 或xlsx （即Excel格式），文件大小不得大于10M
            </div>
            <div>
              <el-upload
                :on-change="uploadChange"
                action="/base/common/importExamUserExcel"
                :data="importData"
                :file-list="importData.fileList"
                :on-success="importSuccess"
                :headers="{ Authorization: getStore('accessToken') }"
                :on-remove="
                  () => {
                    importData.fileList = [];
                  }
                "
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              >
                <el-button type="text" size="mini">上传文件</el-button>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
      <div class="importStep" v-show="importData.step == 1">
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">本次可导入数量</div>
            <div>
              <el-button type="text">{{ importData.successNum }}人</el-button>
            </div>
          </div>
        </div>
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">本次不可导入数量</div>
            <div>
              <el-button type="text">{{ importData.failNum }}人</el-button>
            </div>
          </div>
        </div>
        <h3 v-if="importData.failNum > 0">不可导入列表</h3>
        <el-table
          v-if="importData.failNum > 0"
          :data="importData.failList"
          border
          style="width: calc(100% - 40px); margin: 20px"
        >
          <el-table-column
            prop="userName"
            label="行数"
            type="index"
            width="100"
          >
          </el-table-column>
          <el-table-column prop="userName" label="姓名" width="120">
          </el-table-column>
          <el-table-column prop="sex" label="性别" width="80">
          </el-table-column>
          <el-table-column prop="idCard" label="身份证号" width="180">
          </el-table-column>
          <el-table-column prop="userGroupName" label="部门" width="120">
          </el-table-column>
          <el-table-column prop="positionName" label="职务" width="120">
          </el-table-column>
          <el-table-column prop="moibile" label="手机" width="200">
          </el-table-column>
          <el-table-column prop="msg" label="错误提示" min-width="300">
          </el-table-column
        ></el-table>
      </div>
      <div class="importStep" v-show="importData.step == 2">
        <h1 style="text-align: center">批量导入完成</h1>
        <h3 style="text-align: center">
          成功导入数量:{{ importData.successNum }}人
        </h3>
      </div>
      <div slot="footer">
        <el-button
          type="primary"
          @click="importData.step++"
          v-if="importData.step == 0"
          :disabled="!importData.fileList[0]"
          >下一步</el-button
        >
        <el-button
          type="primary"
          @click="doImportStudentIntoCourse"
          v-if="importData.step == 1"
          >提交并执行</el-button
        >
        <el-button
          type="primary"
          @click="importData.step = 0"
          v-if="importData.step == 1"
          plain
          >返回重新上传</el-button
        >
        <el-button
          type="primary"
          @click="
            importData.ifShow = false;
            getStudentList();
          "
          v-if="importData.step == 2"
          >完成</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="批量导入"
      :visible.sync="importExamData.ifShow"
      width="960px"
      :append-to-body="true"
    >
      <el-steps :active="importExamData.step">
        <el-step title="上传文件"></el-step>
        <el-step title="执行导入"></el-step>
        <el-step title="导入完成"></el-step>
      </el-steps>
      <div class="importStep" v-show="importExamData.step == 0">
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">填写导入准考证的信息</div>
            <div class="detail">
              请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除
            </div>
            <div>
              <!-- <a href="/public/企业学员导入模板.xlsx" icon="md-album"
                >下载模板</a
              > -->

              <el-button
                type="text"
                size="mini"
                @click="download('../导入考生准考证Excel模板.xlsx')"
                >下载模板</el-button
              >
            </div>
          </div>
        </div>
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">上传填好的准考证表</div>
            <div class="detail">
              文件后缀名必须为xls 或xlsx （即Excel格式），文件大小不得大于10M
            </div>
            <div>
              <el-upload
                :on-change="examUploadChange"
                action="/base/common/importExamUserTicket"
                :data="importExamData"
                :file-list="importExamData.fileList"
                :on-success="importExamSuccess"
                :headers="{ Authorization: getStore('accessToken') }"
                :on-remove="
                  () => {
                    importExamData.fileList = [];
                  }
                "
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              >
                <el-button type="text" size="mini">上传文件</el-button>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
      <div class="importStep" v-show="importExamData.step == 1">
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">本次可导入数量</div>
            <div>
              <el-button type="text"
                >{{ importExamData.successNum }}人</el-button
              >
            </div>
          </div>
        </div>
        <div class="importBar">
          <div class="iconSide"></div>
          <div class="detailSide">
            <div class="title">本次不可导入数量</div>
            <div>
              <el-button type="text">{{ importExamData.failNum }}人</el-button>
            </div>
          </div>
        </div>
        <h3 v-if="importExamData.failNum > 0">不可导入列表</h3>
        <el-table
          v-if="importExamData.failNum > 0"
          :data="importExamData.failList"
          border
          style="width: calc(100% - 40px); margin: 20px"
        >
          <el-table-column
            prop="userName"
            label="行数"
            type="index"
            width="100"
          >
          </el-table-column>
          <el-table-column prop="userName" label="姓名" width="120">
          </el-table-column>
          <el-table-column prop="sex" label="性别" width="80">
          </el-table-column>
          <el-table-column prop="idCard" label="身份证号" width="180">
          </el-table-column>
          <el-table-column prop="userGroupName" label="部门" width="120">
          </el-table-column>
          <el-table-column prop="positionName" label="职务" width="120">
          </el-table-column>
          <el-table-column prop="moibile" label="手机" width="200">
          </el-table-column>
          <el-table-column prop="msg" label="错误提示" min-width="300">
          </el-table-column
        ></el-table>
      </div>
      <div class="importStep" v-show="importExamData.step == 2">
        <h1 style="text-align: center">批量导入完成</h1>
        <h3 style="text-align: center">
          成功导入准考证数量:{{ importExamData.successNum }}人
        </h3>
      </div>
      <div slot="footer">
        <el-button
          type="primary"
          @click="importExamData.step++"
          v-if="importExamData.step == 0"
          :disabled="!importExamData.fileList[0]"
          >下一步</el-button
        >
        <el-button
          type="primary"
          @click="doImportExamStudentIntoCourse"
          v-if="importExamData.step == 1"
          >提交并执行</el-button
        >
        <el-button
          type="primary"
          @click="importExamData.step = 0"
          v-if="importExamData.step == 1"
          plain
          >返回重新上传</el-button
        >
        <el-button
          type="primary"
          @click="
            importExamData.ifShow = false;
            getStudentList();
          "
          v-if="importExamData.step == 2"
          >完成</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getStudentGroup,
  deleteStudentGroup,
  editStudentGroup,
  createStudentGroup,
  getStudentList,
  moveStudentGroup,
  getSignupLabelList,
  createSignupLabel,
  deleteSignupLabel,
  createStudent,
  deleteStudent,
  batchDeleteStudent,
  importExamUserExcel,
  importExamUserTicket,
  generateTicket,
  downloadTestTicket,
} from "@/api/examination/student.js";
import mytree from "@/component/tree/mytree.vue";
import treeselect from "@/component/tree/treeSelect.vue";
export default {
  data() {
    return {
      studentGroupTree: [],
      studentList: [],
      searchCondition: {
        jumpPage: 1,
        pageSize: 10,
        groupId: 0,
        total: 0,
      },
      groupMove: {
        ifShow: false,
        clickNode: "",
        ifMulti: false,
      },

      column: {
        faceUrl: true,
        userName: true,
        groupName: true,
        mobile: true,
        sex: true,
      },
      importData: {
        ifShow: false,
        isExecute: 0,
        importFile: null,
        fileList: [],
        failList: [],
        step: 0,
        failNum: 0,
        successNum: 0,
      },
      importExamData: {
        ifShow: false,
        isExecute: 0,
        importFile: null,
        fileList: [],
        failList: [],
        step: 0,
        failNum: 0,
        successNum: 0,
        groupId: "",
      },
      searchKey: "userName",
      searchValue: "",
      tableHeight: document.body.clientHeight - 200,
      editStudentData: {},
      applyKeyvalList: [],
      keyvalSelectList: [],
      ifEditStudent: false,
      newLabelName: "",
      defaultAvatar: require("@/assets/img/defaultAvatar.png"),
    };
  },
  computed: {},
  watch: {
    screenWidth(val) {
      console.log(val + "width");
    },
    screenHeight(val) {
      console.log(val + "height");
    },
  },
  components: { mytree, treeselect },
  created() {},
  mounted() {
    this.studentGroupInit();
    this.getStudentList();
    getSignupLabelList().then((data) => {
      data.unshift({
        name: "分组",
        field: "groupIds",
        type: 1,
        isMust: 1,
      });
      data.forEach((item) => {
        item.field = item.field ? item.field : item.name;
      });
      let applyKeyvalList = data.filter((item) => item.type == 1);

      this.applyKeyvalList = applyKeyvalList;
      this.keyvalSelectList = data;
    });
    window.onresize = () => {
      this.$set(this.$data, "tableHeight", document.body.clientHeight - 200);
    };
  },
  methods: {
    doImportStudentIntoCourse() {
      let formData = new FormData();
      formData.append("file", this.importData.fileList[0]);
      formData.append("isExecute", 1);
      console.log(formData);
      importExamUserExcel(formData).then((data) => {
        this.importData.step = 2;
        // this.getData();
      });
    },
    doImportExamStudentIntoCourse() {
      let formData = new FormData();
      formData.append("file", this.importExamData.fileList[0]);
      formData.append("isExecute", 1);
      formData.append("groupId", this.importExamData.groupId);

      console.log(formData);
      importExamUserTicket(formData).then((data) => {
        this.importExamData.step = 2;
      });
    },
    uploadChange(e) {
      if (e.percentage == 100) {
        this.importData.fileList = [e.raw];
      }
    },
    examUploadChange(e) {
      if (e.percentage == 100) {
        this.importExamData.fileList = [e.raw];
      }
    },
    importSuccess(response, file, fileList) {
      this.importData.importFile = file;
      Object.assign(this.importData, response.data);
    },
    importExamSuccess(response, file, fileList) {
      this.importExamData.importFile = file;
      console.log(response);
      Object.assign(this.importExamData, response.data);
    },
    appendStudent(ifSingle) {
      if (ifSingle) {
        this.editStudentData = this.applyKeyvalList.reduce((total, item) => {
          total[item.field] = item.field == "groupIds" ? [] : "";
          return total;
        }, {});
        this.ifEditStudent = true;
      } else {
        Object.assign(this.importData, this.$options.data().importData);
        this.importData.ifShow = true;
      }
    },
    appendExamStudent(type) {
      this.groupMove.ifMulti = false;
      this.groupMove.ifShow = true;
      this.groupMove.type = type;
      let typeMap = {
        examImport: "请选择导入分组",
        create: "请选择生成分组",
        download: "请选择导出分组",
      };
      this.groupMove.typeText = typeMap[type];
    },
    toEditStudent(item) {
      let editStudentData = {};
      Object.assign(editStudentData, item);
      this.editStudentData = editStudentData;
      // this.$set(this.$data, "editStudentData", editStudentData);
      let applyKeys = Object.keys(item);

      this.applyKeyvalList = this.keyvalSelectList.filter((kv) =>
        applyKeys.includes(kv.field)
      );
      console.log(editStudentData);
      setTimeout(() => {
        this.ifEditStudent = true;
      });
    },
    toDetail(item) {
      this.$router.push({ name: "studentDetail", query: item });
    },
    deleteStudent(item) {
      // if (item.groupIds.length > 1 && this.searchCondition.groupId > 0) {
      //   let groupIds = [...item.groupIds];
      //   groupIds.splice(groupIds.indexOf(this.searchCondition.groupId), 1);
      //   console.log({ userids: [item.id], groupIds });
      //   moveStudentGroup({ userids: [item.id], groupIds }).then(() => {
      //     this.$message.success("已将其移出本分组");
      //   });
      // } else {
      //   deleteStudent({ id: item.id }).then(() => {
      //     this.$message.success("已删除此考生");
      //   });
      // }
      deleteStudent({ id: item.id, groupIds: item.groupIds }).then(() => {
        this.$message.success("移除成功");
        this.getStudentList();
      });
    },
    createLabel() {
      console.log(this.newLabelName);

      createSignupLabel({ customize: this.newLabelName }).then((data) => {
        this.$message.success("新增成功");
        this.newLabelName = "";
        getSignupLabelList().then((data) => {
          data.forEach((item) => {
            item.field = item.field ? item.field : item.name;
          });
          this.keyvalSelectList = data;
        });
      });
    },
    deleteLabel(item) {
      deleteSignupLabel({ id: item.id }).then((data) => {
        this.$message.success("删除成功");

        getSignupLabelList().then((data) => {
          data.forEach((item) => {
            item.field = item.field ? item.field : item.name;
          });
          this.keyvalSelectList = data;
        });
        if (this.applyKeyvalList.some((keyval) => keyval.id == item.id)) {
          this.applyKeyvalList.splice(
            this.applyKeyvalList.findIndex((keyval) => keyval.id == item.id),
            1
          );
          delete this.editStudentData[item.field];
        }
      });
    },
    studentEditKeyTraggle(item, value) {
      if (value) {
        this.applyKeyvalList.push(item);
        this.$set(this.editStudentData, item.field, "");
      } else {
        delete this.editStudentData[item.field];
        this.applyKeyvalList.splice(
          this.applyKeyvalList.findIndex((node) => node.field == item.field),
          1
        );
      }
      this.$forceUpdate();
      console.log(this.applyKeyvalList, this.editStudentData);
    },
    studentEditConfirm() {
      // this.editStudentData.customInformation = {};
      console.log(this.editStudentData);
      createStudent(this.editStudentData).then((data) => {
        this.$message.success("新建成功");
        this.getStudentList();
        this.ifEditStudent = false;
      });
    },
    studentFaceUpload({ file }) {
      console.log(file);
      this.$oss.put(file.uid + Date.now() + ".jpg", file).then((data) => {
        console.log(data);
        this.editStudentData.faceUrl = data.url;
      });
    },
    batchDeleteStudent() {
      this.$confirm(
        `确认删除此${this.$refs.studentListTable.selection.length}条报名吗`,
        "提示",
        {
          confirmButtonText: "删除",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then((data) => {
        batchDeleteStudent({
          ids: this.$refs.studentListTable.selection.map((item) => item.id),
        }).then((data) => {
          this.$message.success("删除成功");
          this.getStudentList();
        });
      });
    },
    getStudentList() {
      let postData = {};
      Object.assign(postData, this.searchCondition);
      if (this.searchValue) {
        postData[this.searchKey] = this.searchValue;
      }
      getStudentList(postData).then((data) => {
        this.studentList = data.records;
        this.searchCondition.total = data.total;
        console.log(data);
      });
    },
    studentGroupInit() {
      getStudentGroup().then((data) => {
        data.unshift({
          id: 0,
          title: "所有分类",
          parentId: 0,
          children: [],
        });
        this.studentGroupTree = data;
      });
    },
    moveStuGroup(ifMulti) {
      if (this.$refs.studentListTable.selection.length < 1) {
        return;
      }
      this.groupMove.ifMulti = ifMulti;
      this.groupMove.ifShow = true;
      this.groupMove.type = false;
    },
    groupMoveConfirm() {
      switch (this.groupMove.type) {
        case "examImport":
          this.groupMove.ifShow = false;
          Object.assign(
            this.importExamData,
            this.$options.data().importExamData,
            {
              ifShow: true,
              groupId: this.groupMove.clickNode.id,
            }
          );
          return;
          break;
        // 生成准考证
        case "create":
          generateTicket({ groupId: this.groupMove.clickNode.id }).then(
            (data) => {
              this.groupMove.ifShow = false;

              this.$message.success("已请求生成准考证");
            }
          );
          return;
          break;
        //下载准考证

        case "download":
          downloadTestTicket({ groupId: this.groupMove.clickNode.id })
            .then((res) => {
              const blob = new Blob([res], { type: "application/zip" }); // new一个二进制对象
              const url = window.URL.createObjectURL(blob); // 转化为url
              const link = document.createElement("a"); // 创建个a标签
              link.href = url;
              link.download = "准考证压缩包"; // 重命名
              link.click();
              URL.revokeObjectURL(url);
              this.groupMove.ifShow = false;
            })
            .catch((err) => {
              console.error(err);
            });

          return;
          break;
        default:
          break;
      }
      if (this.groupMove.ifMulti) {
        moveStudentGroup({
          groupIds: this.$refs.groupMoveTree
            .getCheckedNodes()
            .map((item) => item.id),
          userIds: this.$refs.studentListTable.selection.map((item) => item.id),
        }).then((data) => {
          console.log(data);
          this.$message.success("移动成功");
          this.getStudentList();
          this.groupMove.ifShow = false;
        });
      } else {
        moveStudentGroup({
          groupIds: [this.groupMove.clickNode.id],
          userIds: this.$refs.studentListTable.selection.map((item) => item.id),
        }).then((data) => {
          console.log(data);
          this.$message.success("移动成功");
          this.getStudentList();
          this.groupMove.ifShow = false;
        });
      }
    },
    studentEditGroupEvent(eventDetail, data) {
      switch (eventDetail.type) {
        case "chosenKeysConfirm":
          this.editStudentData.groupIds = eventDetail.chosenKeys;
          break;
        default:
          break;
      }
    },
    studentGroupEvent(eventDetail, data) {
      console.log(eventDetail, data);
      switch (eventDetail.type) {
        case "chosenKeysConfirm":
          this.editStudentData.groupIds = eventDetail.chosenKeys;
          break;
        case "select":
          if (this.groupMove.ifShow) {
            this.groupMove.clickNode = eventDetail.value;
            break;
          }
          if (eventDetail.value.id !== this.searchCondition.groupId) {
            this.searchCondition.jumpPage = 1;
            this.searchCondition.groupId = eventDetail.value.id;
            // this.studentGroupInit();
            this.getStudentList();
          }
          break;
        case "rename":
          editStudentGroup({
            id: eventDetail.contextData.id,
            parentId: eventDetail.contextData.parentId,
            groupName: eventDetail.value,
          }).then(
            (data) => {
              this.$message.success("修改成功");
              this.studentGroupInit();
            },
            (data) => {
              this.$message.error(data || "错误");
            }
          );

          break;
        case "delete":
          deleteStudentGroup({
            id: eventDetail.value,
          }).then(
            (data) => {
              this.$message.success("删除成功");
              this.studentGroupInit();
            },
            (data) => {
              this.$message.error(data || "错误");
            }
          );
          break;
        case "append":
          createStudentGroup({
            parentId: eventDetail.parentId,
            groupName: eventDetail.title,
          }).then(
            (data) => {
              this.$message.success("创建成功");
              this.studentGroupInit();
            },
            (data) => {
              this.$message.success(data || "创建失败");
            }
          );
          break;
        case "move":
          editStudentGroup({
            id: eventDetail.id,
            parentId: eventDetail.parentId,
            groupName: eventDetail.title,
          }).then(
            (data) => {
              this.$message.success("移动成功");
              this.studentGroupInit();
            },
            (data) => {
              this.$message.error(data || "移动失败");
            }
          );
          break;
        default:
          break;
      }
    },
    handleSelectionChange(...e) {
      console.log(e);
    },
    sliderClick(event) {
      let widthReduce = document.body.scrollWidth * 0.135;
      let widthMin = widthReduce + 150;
      document.onmousemove = (event) => {
        if (event.screenX > widthMin) {
          this.$refs.treeBox.style.width = event.screenX - widthReduce + "px";
        }
      };
      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
    download(url) {
      location.href = url;
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .twoSideBox {
    display: flex;
    position: relative;
    // max-height: 80vh;
    .leftBox {
      padding-top: 5px;
      // width: 200px;
      background: #fff;
    }
    .slider {
      width: 8px;
      background: rgba(0, 0, 0, 0.1);
      cursor: w-resize;
    }
    .rightBox::-webkit-scrollbar {
      display: none;
    }
    .rightBox {
      flex: 1;
      padding: 0 15px;
      min-height: 30vh;
      //   max-height: 80vh;
      overflow: scroll;
      .searchBar {
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
      }
    }
  }
}
.tableAvatar {
  width: 40px;
  height: 40px;
}
.el-pagination {
  padding: 0;
}
.avatar-uploader {
  height: 70px;
  margin-top: 5px;
}
/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 68px;
  height: 68px;
  line-height: 68px;
  text-align: center;
}
/deep/ .avatar {
  width: 68px;
  height: 68px;
  display: block;
  object-fit: contain;
}
/deep/ .el-dialog {
  ::-webkit-scrollbar {
    width: 4px; /*对垂直流动条有效*/
    //   height: 10px; /*对水平流动条有效*/
  }
  /*定义滑块颜色、内阴影及圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 7px;
    //   -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #e8e8e8;
  }
  .el-dialog__body {
    padding: 0 20px;
    .el-form {
      padding: 0;
    }
  }
}
.importStep {
  padding: 40px 0;
  .importBar {
    border: 1px solid #ccc;
    display: flex;
    align-items: center;
    margin: 20px 0;
    .iconSide {
      width: 200px;
    }
    .detailSide {
      flex: 1;
      padding: 10px 0;
      .title {
        font-size: 24px;
        line-height: 42px;
      }
      .detail {
        color: #999;
        line-height: 36px;
      }
    }
  }
}
</style>
